
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/share/sound-of-freedom",
      function () {
        return require("private-next-pages/[locale]/share/sound-of-freedom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/share/sound-of-freedom"])
      });
    }
  